import React from 'react'
import { useTranslation } from 'react-i18next'
import { Combobox } from '~/components/ui/combobox'
import { IInspectionChecklist } from '~/utils/types'
import { useChecklistOptions } from './useChecklistOptions'
import { useChecklistValue } from './useChecklistValue'

interface ChecklistSelectContainerProps {
  aircraftModelId?: string
  customerId?: string
  value?: IInspectionChecklist
  onChange: (value: IInspectionChecklist | undefined) => void
  disabled?: boolean
  error?: boolean
  helperText?: React.ReactNode
  label?: string
  placeholder?: string
}

export const ChecklistSelectContainer: React.FC<ChecklistSelectContainerProps> = ({
  aircraftModelId,
  customerId,
  value,
  onChange,
  disabled,
  error,
  helperText,
  label,
  placeholder,
}) => {
  const { t } = useTranslation()

  const { genericChecklists, specificChecklists, isLoading } = useChecklistOptions({
    aircraftModelId,
    customerId,
    enabled: true,
  })

  const { formatChecklistDisplay, groupChecklists } = useChecklistValue()

  const groupedOptions = React.useMemo(
    () => groupChecklists(genericChecklists, specificChecklists),
    [genericChecklists, specificChecklists, groupChecklists],
  )

  return (
    <Combobox<IInspectionChecklist>
      groupedOptions={groupedOptions}
      value={value}
      onChange={onChange}
      displayValue={formatChecklistDisplay}
      loading={isLoading}
      disabled={disabled}
      error={error}
      helperText={helperText}
      itemKey={(item) => item._id}
      label={label || t('Select a checklist')}
      placeholder={placeholder || t('Select a checklist')}
      searchPlaceholder={t('Search checklist...')}
    />
  )
}
